import React from 'react';
import { FooterOrganism, AffiliationDispenseOrganism, Slider, ElementCard } from '../../Organisms';
import { Text, Button, Img } from '../../Atoms';
import logo from '../../assets/img/affiliationLogo.png';
import { blue, green, pink, red } from '../../Config/Config'

function TemplatePartenaire(props) {

    const renderElementCard = (color) => {
        return (
            <ElementCard
                classNameElementContainer='actuality-element-container'
                borderColor={color}
                cardContent={
                    <div className="actuality-content-container">
                        <div className="partenaire-content-img-container">
                            <Img src={logo} />
                        </div>
                        <Text text="Qui sont-ils ?" className="partenaire-content-title" />
                        <Text text="Maison Bourgeat, voit le jour en 1879, aujourd’hui c’est l’une des plus anciennes maison de lunetterie française. Elle met en valeur l’artisanat de luxe et la tradition du savoir-faire français, en consacrant son activité autour du sur-mesure." className="actuality-content-text actuality-content-first-text" />
                        <Text text="Quels sont les avantages ?" className="partenaire-content-title" />
                        <Text text="Nous savons qu’il est important d’être bien équipé, c’est pourquoi ce partenariat fait sens.Vous pourrez bénéficiez de .....................................Retrouver la Maison Bourgeat au 134 rue du Faubourg Saint Honoré 75008 ou par téléphone au 01 42 89 05 71." className="actuality-content-text actuality-content-second-text" />
                        <div className="actuality-content-button-container">
                            <Button text="Accéder au site" className="actuality-content-button" style={{ backgroundColor: `${color}` }} />
                        </div>
                    </div>
                }
            />
        )
    }
    return (
        <div className="template-scroll actuality-container">
            <Text text="Partenaires santé" className="actuality-title" />
            <div className="actuality-slider-container">
                <Slider
                    elementNumber={4}
                    contentNumber={window.innerWidth > 768 ? 2 : 1}
                    dotClicked={null}
                    classNameContentContainer='actuality-slider-content-container'
                    element={[
                        renderElementCard(pink),
                        renderElementCard(red),
                        renderElementCard(blue),
                        renderElementCard(green),
                    ]}
                    classNameSliderContainer='actuality-slider'
                />
            </div>
        </div>
    );
}

export default TemplatePartenaire;
